<template>
  <v-container class="pa-0" v-if="data.length > 0">
    <v-card
      v-for="(item, index) in data"
      :key="item.ext ? 'ext' : index"
      :class="{ 'mb-15px': index < data.length - 1, 'no-click-pointer': item.ext }"
      class="card default-banner akciova-ponuka"
      @click="!item.ext && select(item)"
    >
      <template>
        <v-img
          v-if="!isMobile"
          class="banner-image"
          :src="
            item.ext
              ? item.src
              : $router.options.base +
                'upload/img_dashboard_banner/' +
                ($vuetify.theme.dark ? item.pozadie_obrazok_tmavy : item.pozadie_obrazok_svetly)
          "
        >
        </v-img>
        <v-img
          v-else
          class="image-responsive"
          style="widows: 100%"
          :src="
            item.ext
              ? item.src
              : $router.options.base +
                'upload/img_dashboard_banner/' +
                ($vuetify.theme.dark
                  ? item.pozadie_obrazok_mobil_tmavy
                  : item.pozadie_obrazok_mobil_svetly)
          "
        >
        </v-img>
      </template>

      <div v-if="!isMobile && !item.ext" class="banner-content">
        <div class="d-flex">
          <text-group invert xl :btext="item.text_vlavo_titulok" :gap="8" :utext="item.text_vlavo">
          </text-group>
          <div class="mr-auto mt-3px">
            <v-tooltip slot="append" bottom v-if="item.text_vlavo_info.length > 0">
              <template #activator="{ on }">
                <v-icon slot="activator" v-on="on">mdi-help-circle</v-icon>
              </template>
              <span> {{ item.text_vlavo_info }} </span>
            </v-tooltip>
          </div>
          <text-group
            large
            :gap="4"
            class="mt-5px"
            smallHeader
            :btext="item.text_vpravo"
            :utext="''"
          ></text-group>
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import protectedAxios from '../../auth/axios';
import { mapState } from 'vuex';
import TextGroup from '../basic/TextGroup';

export default {
  components: {
    TextGroup,
  },
  props: {
    value: Object,
    isSelected: Boolean,
    select: {
      type: Function,
      default: function (data) {
        if (data.presmerovanie_url) {
          window.open(data.presmerovanie_url, '_blank');
        }
      },
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      data: [],
      reloadingExtBanner: false,
    };
  },

  watch: {
    isMobile: {
      handler() {
        if (this.isExtBanner) {
          this.loadExtBanner(true);
        }
      },
    },
    'pripad.newId': {
      handler() {
        if (this.pripad.newId) {
          this.loadBanners();
        }
      },
    },
    'pripad.cisloPredmetu': {
      handler() {
        if (this.pripad.cisloPredmetu) {
          this.loadBanners();
        }
      },
    },
  },

  computed: {
    ...mapState(['pripad']),

    isExtBanner() {
      return Array.isArray(this.data) && this.data.some(item => item?.ext === true);
    },
  },

  mounted() {
    this.loadBanners();
  },

  beforeDestroy() {
    this.cleanupExtItemUrls();
  },

  methods: {
    async loadBanners() {
      this.cleanupExtItemUrls();
      this.data = [];
      await this.loadExtBanner();
      await this.loadBanner();
    },

    async loadBanner() {
      if (!this.isExtBanner) {
        await protectedAxios
          .get('banner/uvod')
          .then(res => {
            this.data = res.data;
          })
          .catch(e => {
            console.error(e);
            this.data = [];
          });
      }
    },

    async loadExtBanner(reload) {
      if (reload) {
        this.cleanupExtItemUrls();
        this.data = [];
        this.reloadingExtBanner = true;
      }

      try {
        await protectedAxios
          .get('banner/ext', {
            responseType: 'blob',
            params: {
              obcNewId: this.pripad.newId,
              cisloPredmetu: this.pripad.cisloPredmetu,
              mobile: this.isMobile,
            },
          })
          .then(async res => {
            if (res.data && res.data?.size > 0) {
              this.data.push({ ext: true, src: URL.createObjectURL(res.data) });
            }
          });
      } catch (e) {
        console.error('Failed to load ext. banner', e);
      }

      this.reloadingExtBanner = false;
    },

    cleanupExtItemUrls() {
      if (this.isExtBanner) {
        this.data.forEach(it => {
          if (it.ext && it.src && typeof it.src === 'string' && it.src.startsWith('blob:')) {
            URL.revokeObjectURL(it.src);
          }
        });
      }
    },
  },
};
</script>
